export const initialProducts = [
    { id: 1, name: "有機牛奶 1L", sku: "MLK-001", price: 28.5, location: "A3-02", stock: 120 },
    { id: 2, name: "全麥麵包", sku: "BRD-021", price: 18.0, location: "B1-05", stock: 45 },
    { id: 3, name: "橙汁 500ml", sku: "JCE-033", price: 12.0, location: "C2-11", stock: 200 },
    { id: 4, name: "薯片 Original", sku: "SNK-007", price: 9.9, location: "D4-03", stock: 88 },
];

export const initialPromotions = [
    { id: 1, name: "夏日飲品9折", sku: "JCE-033", discount: "10%", startDate: "2026-06-15", endDate: "2026-07-15", priority: 1 },
    { id: 2, name: "麵包買2送1", sku: "BRD-021", discount: "Buy 2 Get 1", startDate: "2026-06-14", endDate: "2026-06-30", priority: 2 },
];

export const monthlyData = [
    { label: "Jan", revenue: 128000, users: 2100 },
    { label: "Feb", revenue: 142000, users: 2340 },
    { label: "Mar", revenue: 135000, users: 2280 },
    { label: "Apr", revenue: 158000, users: 2750 },
    { label: "May", revenue: 171000, users: 3100 },
    { label: "Jun", revenue: 163000, users: 2980 },
];

export const quarterlyData = [
    { label: "Q1 2026", revenue: 405000, users: 6720 },
    { label: "Q2 2026", revenue: 492000, users: 8830 },
    { label: "Q3 2025", revenue: 378000, users: 5900 },
    { label: "Q4 2025", revenue: 431000, users: 7200 },
];